export var CreditPaymentType;
(function (CreditPaymentType) {
    CreditPaymentType["BPI"] = "bpi";
    CreditPaymentType["GCash"] = "gcash";
    CreditPaymentType["Bank"] = "bank";
    CreditPaymentType["BillEase"] = "billease";
})(CreditPaymentType || (CreditPaymentType = {}));
